import React from 'react';
import { createRoot } from 'react-dom/client';
import SkillUniverse from '../components/skill_universe/SkillUniverse.jsx';

function parseJson(raw) {
  if (!raw) return undefined;
  try { return JSON.parse(raw); } catch (e) { return undefined; }
}

function mountAll() {
  document.querySelectorAll('[data-skill-universe]').forEach((el) => {
    if (el.dataset.mounted) return;
    el.dataset.mounted = 'true';
    el.innerHTML = '';
    createRoot(el).render(
      <SkillUniverse url={el.dataset.url} variant={el.dataset.variant || 'explorer'} ctaLabel={el.dataset.ctaLabel} ctaPath={el.dataset.ctaPath} mapPath={el.dataset.mapPath}
        overlay={parseJson(el.dataset.overlay)} lessonCounts={parseJson(el.dataset.lessonCounts)} topicUrl={el.dataset.topicUrl} />
    );
  });
}

document.addEventListener('DOMContentLoaded', mountAll);
document.addEventListener('turbo:load', mountAll);
if (document.readyState !== 'loading') mountAll();
